/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdminSchedulingLinkId,
  AvailabilityFeature,
  CreateMeetingAttemptRequestV3,
  MapString,
  MeetingAttemptResponseV3,
  MeetingAttemptV3,
  MeetingReservation,
  ReserveTimeSlotRequestV3,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V3<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "user-availability";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Reserve a timeslot to prevent it from being double booked by CP. By default it checks if slot can be reserved
   *
   * @tags Availability
   * @name PostApiV3PublicTenantTenantidUsersSlots
   * @request POST:/v3/public/tenant/{tenantId}/users/slots
   */
  postApiV3PublicTenantTenantidUsersSlots = (
    tenantId: string,
    data: ReserveTimeSlotRequestV3,
    query?: {
      /** @default [] */
      feature?: AvailabilityFeature[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingReservation,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/public/tenant/${tenantId}/users/slots`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV3PublicTenantTenantidUsersSlots */
  postApiV3PublicTenantTenantidUsersSlotsPathGetter = (
    tenantId: string,
    query?: {
      /** @default [] */
      feature?: AvailabilityFeature[];
    },
  ) => this.getServicePath(`/v3/public/tenant/${tenantId}/users/slots`, query);

  /**
   * No description
   *
   * @tags Meeting Attempt
   * @name GetMeetingAttemptV3
   * @request GET:/v3/public/tenant/{tenantId}/meeting-attempt/{meetingAttemptId}
   */
  getMeetingAttemptV3 = (tenantId: string, meetingAttemptId: string, params: RequestParams = {}) =>
    this.request<
      MeetingAttemptResponseV3,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/public/tenant/${tenantId}/meeting-attempt/${meetingAttemptId}`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getMeetingAttemptV3 */
  getMeetingAttemptV3PathGetter = (tenantId: string, meetingAttemptId: string) =>
    this.getServicePath(`/v3/public/tenant/${tenantId}/meeting-attempt/${meetingAttemptId}`);

  /**
   * No description
   *
   * @tags Meeting Attempt
   * @name CreateMeetingAttemptV3
   * @request POST:/v3/tenant/{tenantId}/meeting-attempt
   * @secure
   */
  createMeetingAttemptV3 = (tenantId: string, data: CreateMeetingAttemptRequestV3, params: RequestParams = {}) =>
    this.request<
      MeetingAttemptV3,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/meeting-attempt`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createMeetingAttemptV3 */
  createMeetingAttemptV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/meeting-attempt`);
}
